var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e2e-gfx3d-submit"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(_vm.fragment.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }